









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "ui-popup-window",
  components: {}
})
export default class PopupWindowsomponent extends Vue {
  @Prop({ default: "right" }) position: string;
  @Prop({ default: "" })
  title: string;

  isShow: boolean = false;
  remove() {}
  mounted() {
    // todo : на click
    this.$el.parentElement.addEventListener(
      "mouseover",
      this.onFocus.bind(this, true)
    );
    this.$el.parentElement.addEventListener(
      "mouseleave",
      this.onLeave.bind(this, false)
    );
  }
  beforeDestroy() {
    this.$el.parentElement.removeEventListener(
      "mouseover",
      this.onFocus.bind(this, true)
    );
    this.$el.parentElement.removeEventListener(
      "mouseleave",
      this.onLeave.bind(this, false)
    );
  }
  onFocus() {
    this.isShow = true;
  }
  onLeave() {
    this.isShow = false;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-popup-window/src/ui-popup-window.vue